import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "./NotificationBell.css";

const NotificationBell = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <div className="notification-container">
      {/* ✅ Notification Strip with Bell Icon */}
      <div className="notification-strip">
        <button className="notification-bell" onClick={togglePopup}>
          <FontAwesomeIcon icon={faBell} size="lg" />
        </button>
      </div>

      {/* ✅ Notification Popup - Appears Next to the Strip */}
      {showPopup && (
        <div className="notification-popup">
          <button className="close-btn" onClick={togglePopup}>
            &times;
          </button>
          <img
            src="/admissionformback.jpg"
            alt="Admission Open"
            className="notification-img"
          />
          <p><strong>Admission Open 2025-26 🎉</strong></p>
          <p>Join Shri Kheteshwar Gurukul for the upcoming session!</p>
          <a href="/admission" className="apply-btn">
            Apply Now
          </a>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
